import { useCallback, useEffect, useState } from "react";
import { JokeData } from "../../presentation/components";

export const useFetchJoke = (shouldFetch = false) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [joke, setJoke] = useState<JokeData | undefined>();

  const fetchJoke = useCallback(() => {
    setLoading(true);

    fetch("https://v2.jokeapi.dev/joke/Any?type=single")
      .then((res) => res.json())
      .then((data) => {
        setJoke({ type: data.type, joke: data.joke });
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (shouldFetch) {
      fetchJoke();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetch]);

  return { loading, error, joke, refetch: fetchJoke };
};
